module.exports = __webpack_public_path__ + "static/img/9.81e9efe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/9.jpg
// module id = f6eB
// module chunks = 5